import React from "react";
import { Link } from "react-router-dom";
import { ClipboardList, CalendarDays, MessageSquare, AlertTriangle, Globe2, BookMarked, CheckCircle2, ArrowRight } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PageHero, Section, SectionHeading } from "@/components/blocks";

const MENTOR_TOOLKIT = [
  { icon: ClipboardList, title: "First-day checklist" },
  { icon: CalendarDays, title: "Weekly meeting templates" },
  { icon: MessageSquare, title: "Feedback templates" },
  { icon: AlertTriangle, title: "Difficult conversations guide" },
];

const SCHOOL_TOOLKIT = ["Mentor handbook", "Induction templates", "Welcome booklet", "Placement planning resources"];

export default function MentorsSchools() {
  return (
    <div data-testid="mentors-schools-page">
      <PageHero
        eyebrow="Mentors & Schools"
        title="Support the next generation of educators."
        subtitle="Practical toolkits and professional learning that make mentoring pre-service teachers structured, confident and rewarding."
        image="https://images.unsplash.com/photo-1524178232363-1fb2b075b655?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      />

      <Section>
        <SectionHeading eyebrow="Mentor Teacher Toolkit" title="Everything a mentor needs, ready to use" />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {MENTOR_TOOLKIT.map((t) => (
            <Card key={t.title} className="p-6 border-slate-200 text-center" data-testid={`mentor-tool-${t.title}`}>
              <div className="w-12 h-12 rounded-xl bg-teal-600 flex items-center justify-center mx-auto mb-4"><t.icon className="w-6 h-6 text-white" /></div>
              <p className="font-semibold text-slate-800 text-sm">{t.title}</p>
            </Card>
          ))}
        </div>
      </Section>

      <div className="bg-slate-50 border-y border-slate-200">
        <Section>
          <div className="grid md:grid-cols-2 gap-8">
            <Card className="p-8 border-slate-200 bg-white">
              <Globe2 className="w-9 h-9 text-emerald-600 mb-4" />
              <h3 className="font-display text-xl font-bold text-slate-900 mb-2">Supporting International PSTs</h3>
              <p className="text-slate-600">Resources and training modules to help mentor teachers effectively support international pre-service teachers as they adapt to Australian school culture.</p>
            </Card>
            <Card className="p-8 border-slate-200 bg-white">
              <BookMarked className="w-9 h-9 text-teal-600 mb-4" />
              <h3 className="font-display text-xl font-bold text-slate-900 mb-4">School Placement Toolkit</h3>
              <ul className="grid grid-cols-2 gap-2.5">
                {SCHOOL_TOOLKIT.map((s) => <li key={s} className="flex items-start gap-2 text-slate-700 text-sm"><CheckCircle2 className="w-4 h-4 text-emerald-500 mt-0.5 shrink-0" /> {s}</li>)}
              </ul>
            </Card>
          </div>
          <div className="text-center mt-10">
            <Button asChild size="lg" className="bg-teal-600 hover:bg-teal-700 rounded-full px-8"><Link to="/contact" data-testid="mentors-cta">Enquire about mentor training <ArrowRight className="w-4 h-4" /></Link></Button>
          </div>
        </Section>
      </div>
    </div>
  );
}
